module.exports = __webpack_public_path__ + "img/cropped-tyrel-johnson-qzOAhs1cYn4-unsplash-compressed-large.b26daad6.webp";